<!-- 商户管理/账号管理 -->
<template>
  <el-table :data="tableData" style="width: 100%;border: 1px solid #f1f1f1">
    <el-table-column sortable label="编号" prop="id" align="center" width="80">
    </el-table-column>
    <el-table-column
      label="账号"
      prop="number"
      align="center"
    ></el-table-column>
    <el-table-column label="商户" prop="name" align="center"></el-table-column>
    <el-table-column
      label="角色名称"
      prop="role"
      align="center"
    ></el-table-column>
    <el-table-column label="操作" align="center">
      <template slot-scope="scope">
        <div class="table_button_line">
          <el-button type="text" @click="editShopDetail(scope.row.id)"
            >角色设置</el-button
          >
          <el-button type="text">修改密码</el-button>
          <el-button type="text">删除</el-button>
        </div>
      </template>
    </el-table-column>
  </el-table>
</template>
<script>
export default {
  props: {
    tableData: {
      type: Array,
      default: function() {
        return [];
      }
    }
  },
  methods: {
    editShopDetail(id) {
      console.log(id);
    }
  }
};
</script>
